module.exports = __webpack_public_path__ + "img/avatar-omkar-pimple.ce432fa0.jpg";